import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { People } from "@/components/icons/people";
import SyncedListNotice from "@/components/import-list/synced-list-notice-component";

type SyncedSpeakersSettingsProps = {
  minimal?: boolean;
};

export default function SyncedSpeakersSettings({
  minimal = false,
}: SyncedSpeakersSettingsProps) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const slug = query.slug as string;

  return (
    <SyncedListNotice
      title={t("preference-panel.block-display-name.speakers-synced")}
      icon={People}
      path="speakers"
      eventSlug={slug}
      minimal={minimal}
    >
      {t("preference-panel.speakers.embedded-speakers-synced")}
    </SyncedListNotice>
  );
}
